import { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { ButtonProps, Box, ChakraProps } from '@chakra-ui/react';
import { ContentForm as FormProps } from '@/types';
import type { SalesOrderFormProps } from '@/components/frontend/SalesOrderForm';

export type FormChildren = (closeButtonProps?: ButtonProps) => ReactNode;

export interface FormChildrenProps {
  children?: FormChildren;
}

const SalesOrderForm = dynamic(
  () => import('@/components/frontend/SalesOrderForm'),
);

// TODO: dynamically import each used form. Render with responsibility whether to ssr or no. Fetch required app data in the form on client side if necessary.

const FormSelector = ({
  type,
  ...rest
}: FormChildrenProps & FormProps & ChakraProps) => {
  switch (type) {
    case 'forest_valuation':
      return <p>Forest valuation widget PLACEHOLDER</p>;
    case 'contact':
      return <Box as="form" {...rest} />;
    case 'sales_order':
      return (
        <SalesOrderForm {...(rest as SalesOrderFormProps & ChakraProps)} />
      );
    default:
      throw new Error(`No such form type ${type as string}`);
  }
};

export default FormSelector;
